import { useEffect, useState } from "react";
import $ from "jquery";
import {
    updateWithInputApplyEventHandler,
    enableOtherThanIndexRows,
    getDefaultBid,
} from "@ts/utils";
import { ICellRendererParams } from "ag-grid-community";
import { FaCheck, FaTrashAlt } from "react-icons/fa";
import useGetModulesData from "@/hooks/useGetModulesData";

interface IUpdateWithInputCellRenderer extends ICellRendererParams {
    hasApplyButton: boolean;
    hasCancelButton: boolean;
    isThirdPartyRequestOnApply: boolean;
    origin: string;
    isDisabled: boolean;
    // Unable to access its type as its private type in ag-grid
    column: any;
}

const UpdateWithInputCellRenderer: React.FC<IUpdateWithInputCellRenderer> = (
    params
) => {
    const [identifier, setIdentifier] = useState<string>("");
    const MAX_CHARS = 50;
    const gridParams = useGetModulesData({
        type: "grid-params",
    })

    useEffect(() => {
        if (params.data) {
            let name;
            let keywordText;
            switch (params.origin) {
                case "campaign-creation-targets":
                    setIdentifier(
                        `${params.data.prod_target}__${params.data.program_type}__${params.data.tgt_class}__${params.data.tgt_type}__${params.data.match_type}`
                    );
                    break;

                case "campaign-creation":
                    name = params.data.name
                        .split(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/)
                        .filter((e: string) => e)
                        .join("-");
                    setIdentifier(
                        `${name}__${params.data.campaignType}__${params.data.targetingType}__${params.data.targetingClass}`
                    );
                    break;

                case "keyword-recommendation":
                    setIdentifier(
                        `${params.data.ad_group}__${params.data.campaign}__${
                            params.data.program_type
                        }__${params.data.search_term.split(" ").join("-")}__${
                            params.data.targeting_class
                        }__${params.data.targeting_type}__${
                            params.node.rowIndex + 1
                        }`
                    );
                    break;

                case "bulk-keyword-addition":
                    keywordText = params.data.keywordText
                        .replace(/[^a-zA-Z0-9]+/g, "_")
                        .replace(/^_+|_+$/g, "");
                    setIdentifier(
                        `${keywordText}__${params.data.adGroupId}__${params.data.campaignId}__${params.data.matchType}__${params.data.programType}`
                    );
                    break;

                case "campaign-headline":
                    name = params.data.name
                        .split(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/)
                        .filter((e: string) => e)
                        .join("-");
                    setIdentifier(
                        `${name}__${params.data.campaignType}__${params.data.targetingType}__${params.data.targetingClass}__headline`
                    );
                    break;

                default:
                    setIdentifier("");
                    break;
            }
        }
    }, [params.origin, params.data, params.node.rowIndex]);

    const [isUIDisabled] = useState(
        identifier === "00000000000000" ||
            gridParams.excludedBidProgramType?.includes(params.data.programType)
    );

    function updateValueOfInputElement(
        rowParams: IUpdateWithInputCellRenderer,
        rowIdentifier: string
    ) {
        const updateElement = document.getElementById(
            `${rowParams.column.colId}-${rowIdentifier}-update-field`
        ) as HTMLInputElement;

        if (rowParams.isThirdPartyRequestOnApply) {
            updateWithInputApplyEventHandler(updateElement);
        } else if (rowParams.origin === "campaign-headline") {
            rowParams.setValue(updateElement.value);
        } else {
            rowParams.setValue(+updateElement.value);
        }
    }

    function updateWithInputCancelEventHandler(element: any) {
        // TODO needs discussion
        $(element)
            .parent()
            .find("input")
            .val(element.getAttribute("data-original-value"));
        enableOtherThanIndexRows(element.getAttribute("data-id"));
    }

    return (
        <>
            {params.node.rowPinned ? null : (
                <>
                    <div
                        className="ag-cell-wrapper updateInput in"
                        id={`${params.column.colId}-${identifier}-btn`}
                    ></div>

                    <div
                        className=""
                        style={{
                            display:
                                params.origin === "campaign-headline"
                                    ? "inline"
                                    : "block",
                        }}
                    >
                        {params.origin === "campaign-headline" ? (
                            <>
                                <input
                                    type="text"
                                    id={`${params.column.colId}-${identifier}-update-field`}
                                    data-id={identifier}
                                    className="form-control border border-primary"
                                    defaultValue={params.data.headline || ""}
                                    maxLength={50}
                                    disabled={isUIDisabled}
                                    style={{
                                        display:
                                            params.data.campaignType ===
                                            "sponsoredBrands"
                                                ? "block"
                                                : "none",
                                    }}
                                    onInput={() => {
                                        const length = (
                                            document.getElementById(
                                                `${params.column.colId}-${identifier}-update-field`
                                            ) as HTMLInputElement
                                        ).value.length;
                                        const charsDiv =
                                            document.getElementById(
                                                `remainingCharsDiv-${
                                                    params.node.rowIndex + 1
                                                }`
                                            );
                                        const remaining_chars =
                                            MAX_CHARS - length;
                                        const color =
                                            remaining_chars < MAX_CHARS * 0.1
                                                ? "red"
                                                : "green";
                                        charsDiv.style.color = color;
                                        charsDiv.textContent = `${remaining_chars} characters remaining`;
                                    }}
                                    onChange={(e) => {
                                        params.setValue(e.target.value);
                                    }}
                                    onBlur={() => {
                                        const charsDiv =
                                            document.getElementById(
                                                `remainingCharsDiv-${
                                                    params.node.rowIndex + 1
                                                }`
                                            );
                                        charsDiv.textContent = "";
                                    }}
                                />
                                <div
                                    id={`remainingCharsDiv-${
                                        params.node.rowIndex + 1
                                    }`}
                                    style={{
                                        display:
                                            params.data.campaignType ===
                                            "sponsoredProducts"
                                                ? "none"
                                                : "block",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        textAlign: "right",
                                    }}
                                ></div>
                            </>
                        ) : (
                            <>
                                <input
                                    type="number"
                                    id={`${params.column.colId}-${identifier}-update-field`}
                                    data-id={identifier}
                                    className="form-control border border-primary"
                                    defaultValue={
                                        params.origin ===
                                            "keyword-recommendation" &&
                                        params.data[params.column.colId] ===
                                            null
                                            ? getDefaultBid()
                                            : params.data[params.column.colId]
                                    }
                                    onChange={(e) => {
                                        params.setValue(+e.target.value);
                                    }}
                                    disabled={
                                        params.data.campaignType !==
                                            "sponsoredProducts" &&
                                        params.isDisabled
                                            ? true
                                            : isUIDisabled
                                    }
                                />
                            </>
                        )}

                        {params.hasApplyButton ? (
                            <button
                                className="btn btn-light px-2 border-start border-top-0 border-bottom-0 border-primary"
                                id={`apply-update-${params.column.colId}-btn-${identifier}`}
                                type="button"
                                value="Apply"
                                onClick={() =>
                                    updateValueOfInputElement(
                                        params,
                                        identifier
                                    )
                                }
                            >
                                <FaCheck />
                            </button>
                        ) : (
                            ($(
                                `${params.column.colId}-${identifier}-update-field`
                            ).focusout(function () {
                                updateValueOfInputElement(params, identifier);
                            }) as any)
                        )}

                        {params.hasCancelButton && (
                            <button
                                className="btn btn-light px-2"
                                id="cancel-btn"
                                type="button"
                                value="Cancel"
                                data-original-value={
                                    params.data[params.column.colId]
                                }
                                // TODO Discuss about it. It's present in RevinitiRecommendations
                                onClick={(
                                    e: React.MouseEvent<
                                        HTMLButtonElement,
                                        MouseEvent
                                    >
                                ) => updateWithInputCancelEventHandler(e)}
                            >
                                <FaTrashAlt />
                            </button>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default UpdateWithInputCellRenderer;
